import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';

import { isMobile, urlFormatter, useWindowSize } from '../../../util';

import './search.scss';
import Translation from 'services/translation.service';
import { useState, useEffect } from 'react';
import searchIcon from '../../../assets/img/icon/header-search-icon.svg';
import searchIconOpened from '../../../assets/img/icon/header-search-icon_open.svg';

const Search = ({ links }) => {
  const [showResults, setShowResults] = useState(false);
  const [searchKey, setSearchKey] = useState(null);
  const [expand, setExpand] = useState(false);
  const [width, height] = useWindowSize();

  // useEffect(() => !showResults && setShowResults(false), [showResults]);

  const searchResults = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    setShowResults(true);
  };

  const handleInput = (event) => {
    var text = event.target.value;
    setSearchKey(text);
  };

  const onKeyPress = (event) => {
    if (event.key === 'Enter' && searchKey) {
      searchResults();
    }
  };

  let redirect = null;
  let routeLink = urlFormatter(
    '/' + links?.['informative-search_results']?.['route']
  );
  let searchLink = routeLink.substring(0, routeLink.indexOf(':'));
  if (showResults) {
    redirect = <Redirect to={searchLink + searchKey} comingFrom="Support" />;
  }

  return (
    <>
      {isMobile() ? (
        <div className="search-box upper-section intro">
          {/* <h1 className="intro-title">{props.mainTitle}</h1> */}
          <div className="search">
            <form className="search-input-wrapper" onSubmit={searchResults}>
              <input type="submit" value="search" className="search-btn" />
              <input
                type="text"
                placeholder={Translation.key('web_srch_lbl1.2_srchher')}
                className="search-input"
                onChange={(event) => handleInput(event)}
                onKeyPress={(event) => onKeyPress(event)}
              />
            </form>
          </div>
        </div>
      ) : (
        <form
          className={`expandable-search userDataMenuLabel ${
            expand ? 'expanded' : ''
          }`}
          onSubmit={searchResults}
        >
          <img
            src={expand ? searchIconOpened : searchIcon}
            onClick={() => setExpand(!expand)}
          />
          <input
            className={`search ${expand ? 'expanded' : ''}`}
            type="search"
            placeholder={Translation.key('navbar_search')}
            onChange={(event) => handleInput(event)}
            onKeyPress={(event) => onKeyPress(event)}
          />
        </form>
      )}
      {redirect}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    links: state.layout.routes,
    currentRoute: state.layout.currentRoute,
  };
};

export default connect(mapStateToProps)(Search);
